import { VOICE_EXPERIENCES_PAGE } from "@/data/marketing/capabilityPages";
import SegmentLandingPage from "@/pages/Segments/SegmentLandingPage";

const VoiceExperiencesPage = () => {
  return <SegmentLandingPage content={VOICE_EXPERIENCES_PAGE} />;
};

export default VoiceExperiencesPage;
